import {Component, OnInit, OnDestroy, Input} from '@angular/core';
import {OrderService} from '../../services/order.service';
import {Order} from '../../interfaces/order';
import {Utility} from '../../utility';
import * as Query from '../../global-query';
import {Observable} from 'rxjs/Observable';
import listMenu from '../../graphql/queries/listMenu';
import {AppsyncService} from '../../services/appsync.service';

import subscribeToNewUserOrders from '../../graphql/subscriptions/subscribeToNewOrder';
import DeleteOrderSubscription from '../../graphql/subscriptions/DeleteOrderSubscription';
import UpdateOrderSubscription from '../../graphql/subscriptions/UpdateOrderSubscription';

import {getAllItemsQuery as ItemsQuery} from '../../graphql/operation-result-types';
import {addItem} from '../../lunch-helper';

import * as _ from 'lodash';
import update from 'immutability-helper';
import NewItemSubscription from '../../graphql/subscriptions/NewItemSubscription';
import UpdateItemSubscription from '../../graphql/subscriptions/UpdateItemSubscription';
import DeleteItemSubscription from '../../graphql/subscriptions/DeleteItemSubscription';
import {UserService} from '../../services/user.service';
import {ItonicsAuthService} from '../../services/itonicsAuth.service';
import {item} from '../../item';
import { Subscription } from 'rxjs';
import { Settings } from '../../interfaces/setting';
import { SettingService } from '../../services/setting.service';

@Component({
  selector: 'app-today-order-list',
  templateUrl: './today-order-list.component.html',
  styleUrls: ['./today-order-list.component.scss']
})
export class TodayOrderListComponent implements OnInit {
  _order;

  @Input()
  set order(order) {
    this._order = order;
    if (this._order) {
      this.getTodayOrder();
    }
  }

  userDatalist: any = [];
  inactiveUsers: any = [];
  public netToken = 0;
  public netTokenAll = 0;

  public extraTotal = 0;
  public extraTotalAll = 0;
  public selectedIndex = 'all';

  public uid = 0;

  settingSubscrition: Subscription;
  public settingsData: any = [];

  public counterValue = 1;

  public todayItemsList: Order[] = [];
  public todayItemsLists: any = [];
  public orderList: any = [];
  isAdmin = false;
  public loggedInGrp = [];

  // public todayItemsList: Observable<Order[]>;

  orderLists: Order[] = [];

  constructor(
    private orderService: OrderService,
    private appsync: AppsyncService,
    private uservice: UserService,
    private itonicsAuthService: ItonicsAuthService,
    private settingService: SettingService,
  ) {
    this.itonicsAuthService.getCurrentUserGrp().subscribe(
      (userGrp) => {
        this.loggedInGrp = userGrp;
        if (this.loggedInGrp.find((_grp) => _grp === 'Administrator')) {
          this.isAdmin = true;
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  ngOnInit() {
    this.uservice
      .getUserList()
      .toPromise()
      .then((data) => {
        this.userDatalist = data;
        this.getTodayOrder();
      });
  }


  filterOrders(type) {
    this.getTodayOrder(type);
    this.selectedIndex = type;
  }

  getTodayOrder(type = null) {
    this.appsync.client.hydrated().then((client) => {
      const observable = client.watchQuery({
        query: Query.orderByDate,
        variables: {
          date: Utility.getTodayDate()
        }
      });

      let settingdata;
      this.settingSubscrition = this.settingService.settings.subscribe((settings: Settings) => {
        settingdata = settings;
        if (settingdata.length == 0) {
          // console.log('no data')
          return
        }
        settingdata.forEach(element => {
          this.settingsData[element.alias] = element.value;
        });

      observable.subscribe(({data, loading}) => {
        if (!data) {
          return console.log('getTodayOrder - no data');
        }

        console.log('getTodayOrder', data);
        this.uid = 0; // Intialize again so when data fetch again from subscription, there is not old data.
        this.orderLists = _(data.orderListByDate)
          .sortBy('userId')
          .value();
        console.log(this.orderLists);

        this.extraTotal = 0;
        this.netToken = 0;
        const reformattedArray = this.orderLists.map((obj) => {
          const newObject: any = Object.assign({}, obj);

          newObject['date'] = Utility.convert(obj['date']);
          newObject.menuItemId = obj['menuItem']['id'];
          newObject.net = Math.round(obj['menuItem']['price'] * obj['quantity']);
          newObject.packing = obj.packing;
          newObject.total = Math.round(obj.quantity * obj['menuItem'].price - obj.quantity * obj['menuItem'].price * 0.87 * (this.settingsData.discount / 100));
          /* if (newObject.total > this.settingsData.lunchamount) {
             newObject.extra = newObject.total - this.settingsData.lunchamount;
             this.extraTotal += newObject.extra;
           } else {
             newObject.extra = '0';
           }
 */
          this.netToken += newObject.total;

          // if (this.uid != obj.userId) {
          // this.uid = obj.userId;
          // console.log(this.userDatalist);
          const userDetail = this.userDatalist.filter((u) => u.Username === obj.userId);
          if (userDetail[0]) {
            newObject.indexId = userDetail[0].name + ' ' + userDetail[0].family_name;
          } else {
            newObject.indexId = 'Anonymus';
          }
          // } else {
          // newObject.indexId = '';
          // }

          return newObject;
        });

        this.todayItemsList = reformattedArray;

        console.log(this.orderList);
        if (type === 'table') {
          this.todayItemsList = this.todayItemsList.filter((t) => t.packing === false);
          console.log(this.orderList);
        } else if (type === 'packing') {
          this.todayItemsList = this.todayItemsList.filter((t) => t.packing === true);
          console.log(this.orderList);
        } else {
        }

        this.todayItemsLists = this.todayItemsList.reduce((p, n) => {
          if (!p[n.userId]) {
            p[n.userId] = [];
          }
          p[n.userId].push(n);
          return p;
        }, {});

        this.orderList = [];
        Object.keys(this.todayItemsLists).forEach((key) => {
          const tempObj = [];
          let total = 0;
          tempObj['data'] = this.todayItemsLists[key];
          this.todayItemsLists[key].forEach((value) => {
            total += value.total;
          });
          // test['extra'] = total;

          if (total > this.settingsData.lunchamount) {
            tempObj['extra'] = total - this.settingsData.lunchamount;
            this.extraTotal += tempObj['extra'];
          } else {
            tempObj['extra'] = '0';
          }

          // this.netToken += total;


          this.orderList.push(tempObj);
        });
        const userIds = this.todayItemsList.map((itemY) => {
          return itemY.userId;
        });

        this.inactiveUsers = this.userDatalist.filter((user) => !userIds.includes(user.Username));

        if (type === 'all' || type === null) {
          this.netTokenAll = this.netToken;
          this.extraTotalAll = this.extraTotal;
        }
      });

      })

      observable.subscribeToMore({
        document: subscribeToNewUserOrders,

        updateQuery: (
          prev,
          {
            subscriptionData: {
              data: {subscribeToNewOrder: order}
            }
          }
        ) => {
          console.log('Subscription Order add', prev, order);

          if (!prev || !prev.orderListByDate) {
            return {orderListByDate: []};
          }

          if (prev.orderListByDate.find((_item) => _item.id === order.id)) {
            return prev;
          }

          return update(prev, {orderListByDate: {$push: [order]}});
        }
      });

      observable.subscribeToMore({
        document: UpdateOrderSubscription,
        updateQuery: (
          prev,
          {
            subscriptionData: {
              data: {onUpdateOrder: item}
            }
          }
        ) => {
          console.log('Subscription Order update', prev, item);

          if (!prev || !prev.orderListByDate) {
            return {orderListByDate: []};
          }
          const updatedId = item.id;
          const index = prev.orderListByDate.findIndex((order) => order.id === updatedId);
          console.log(updatedId, ' ', index);
          return update(prev, {
            orderListByDate: {
              [index]: {
                subset: {
                  $set: [item]
                }
              }
            }
          });
        }
      });

      observable.subscribeToMore({
        document: DeleteOrderSubscription,
        updateQuery: (
          prev,
          {
            subscriptionData: {
              data: {onDeleteOrder: item}
            }
          }
        ) => {
          console.log('Subscription Order delete', prev, item);

          if (!prev || !prev.orderListByDate) {
            return {orderListByDate: []};
          }

          /*  if (prev.listMenu.some(_item => _item.id === item.id)) {
                  return prev;
              }*/

          return update(prev, {
            orderListByDate: (arr) => arr.filter((_item) => _item.id != item.id)
          });
        }
      });

      /* observable.subscribeToMore(

           {
               document: subscribeToNewUserOrders,
               updateQuery: (prev, {subscriptionData: {data: {subscribeToNewOrder: order}}}) => {
                   console.log('updateQuery on order subscription', order, prev);
                   //return this._order.id === order.id ? prev : addItem(prev, order);

                   console.log(prev);
                   console.log(order)
                   return addItem(prev, order);
               }
           }
       );*/

      /* observable.subscribe(({data}) => {

           console.log(data);

           if (!data) {
               return console.log('Today order - no data');
           }

       });*/
    });

    /*this.querySubscription = this.apollo.watchQuery<any>({
        query: Query.orderByDate,
        variables: {
            date: Utility.getTodayDate(),
        },
        //pollInterval: 1000
    })
        .valueChanges
        .subscribe(({data, loading}) => {
            /!*          this.todayItemsList = data.orderListByDate;
                      console.log("here ia m");
                      console.log(this.todayItemsList);*!/


            let reformattedArray = data.orderListByDate.map(obj => {
                let newObject: any = Object.assign({}, obj);

                console.log(newObject);

                newObject['date'] = Utility.convert(obj['date']);
                newObject.net = Math.round(obj['menuItem']['price'] * obj['quantity']);
                newObject.total = Math.round((obj.quantity * obj['menuItem'].price) - (obj.quantity * obj['menuItem'].price * 0.13));

                if (newObject.total > this.settingsData.lunchamount) {
                    newObject.extra = newObject.total - this.settingsData.lunchamount;
                    this.extraTotal += newObject.extra;
                } else {
                    newObject.extra = '0';
                }

                this.netToken += newObject.total;

                if (this.uid != obj['user'].email) {
                    this.uid = obj['user'].email;
                    newObject.indexId =  this.counterValue++;
                }else{
                    newObject.indexId =  '';
                }

                return newObject;
            });

            this.todayItemsList = reformattedArray;
        });
*/
  }

  removeUserOrder(_item: item) {
    if (confirm('Are you sure to delete ' + _item['menuItem']['title'])) {
      this.orderService.removeQuickOrder(_item.id).subscribe((something) => {
        this.getTodayOrder();
      });
    }
  }

  editUserOrder(id, menuItemId) {
    window.location.href = ItonicsAuthService.AuthSystemUrl + '/home/edit/order/' + id + '/' + menuItemId;
  }


  checkIfOrderEmpty() {
    if (this.todayItemsList) {
      return true;
    } else {
      return false;
    }
  }

  printOrders() {
    let printContents, popupWin, title;
    if (this.selectedIndex === 'all') {
      title = 'Today`s Order';
    } else if (this.selectedIndex === 'table') {
      title = 'Table Orders';
    } else {
      title = 'Packing Orders';
    }
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>${title}</title>
          <style>
          td{
                border-bottom: 1px solid #353535;
                border-right: 1px solid #353535;
          }
          .hide-print{
          display: none;
          }
          .menu-title span{
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 200px;
            display: inline-block;
          }
           table th,
           table td{
          font-size: 10px;
          }
          </style>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    // popupWin.document.close();
  }


  orderIncreament(uid) {
    console.log(uid);

    /* if (this.uid != uid) {
         console.log(this.uid + "   "+ uid);
         this.uid = uid;
         //console.log(this.counterValue++)
         return this.counterValue++;
     }*/
  }

  /* ngOnDestroy() {
       this.querySubscription.unsubscribe();
   }*/
}



// WEBPACK FOOTER //
// ./src/app/pages/today-order-list/today-order-list.component.ts